export default __webpack_public_path__ + "static/media/eth.dd7f4aa9.png";